import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetProductionLotVariantOptionsQueryVariables = Types.Exact<{
  productionLotId: Types.Scalars['String']['input'];
}>;


export type GetProductionLotVariantOptionsQuery = { __typename?: 'Query', productionLotVariantOptions: { __typename?: 'ProductionLotVariantOptionsPayload', productionLotId: string, options: Array<{ __typename?: 'ProductionLotVariantOption', productionCatalogId: string, isLotSiteVariation: boolean }>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const GetProductionLotVariantOptionsDocument = new TypedDocumentString(`
    query GetProductionLotVariantOptions($productionLotId: String!) {
  productionLotVariantOptions(productionLotId: $productionLotId) {
    productionLotId
    options {
      productionCatalogId
      isLotSiteVariation
    }
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetProductionLotVariantOptions: build.query<GetProductionLotVariantOptionsQuery, GetProductionLotVariantOptionsQueryVariables>({
      query: (variables) => ({ document: GetProductionLotVariantOptionsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetProductionLotVariantOptionsQuery, useLazyGetProductionLotVariantOptionsQuery } = injectedRtkApi;
